/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { ConfirmationModal, SuccessModal } from '../index';
import { useState } from 'react';
import { apiUrl } from '../../utilities/apiUrl';
import { DoNotDisturbAlt } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

export const DeactivateEmpModal = (props) => {
  const [deactivateSuccessOpen, setDeactivateSuccessOpen] = useState(false);

  // DEACTIVATE EMPLOYEE RECORD HANDLER
  const handleDeactivate = () => {
    fetch(apiUrl('/employee/' + props.selectedEmp), {
      method: 'DELETE',
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setDeactivateSuccessOpen(true);
        } else {
          alert(data.message);
        }
      });
  };
  return (
    <>
      <ConfirmationModal
        open={props.open}
        onClose={props.onClose}
        primaryClickHandler={() => {
          handleDeactivate();
          props.onClose();
        }}
        secondaryClickHandler={props.onClose}
        title={
          <Box display="flex" alignItems="center" gap={1}>
            <DoNotDisturbAlt sx={{ fontSize: 30 }} />
            <Typography
              variant="h6"
              fontWeight={600}
              sx={{ color: '#c53838ff' }}
            >
              Deactivate Employee
            </Typography>
          </Box>
        }
        desc={
          <Box>
            <Typography variant="body1" sx={{ mt: 3, mb: 2 }}>
              Are you sure you want to deactivate:
            </Typography>
            <Typography
              variant="h6"
              fontWeight={700}
              color="#c53838ff"
              sx={{ mb: 5 }}
            >
              {props.deactivateName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              This action will deactivate the employee’s account without
              removing any of their data.
            </Typography>
          </Box>
        }
        primaryBtnName={'Deactivate'}
        secondaryBtnName={'Cancel'}
        primaryStyle={{
          bgcolor: '#d32f2f',
          border: '1px solid #d32f2f',
          '&:hover': {
            bgcolor: '#b71c1c !important',
            borderColor: '#b71c1c',
          },
        }}
      />
      <SuccessModal
        open={deactivateSuccessOpen}
        onClose={() => {
          setDeactivateSuccessOpen(false);
          props.resetIndex();
          window.location.reload();
        }}
        close={() => {
          setDeactivateSuccessOpen(false);
          props.resetIndex();
          window.location.reload();
        }}
        desc={'You have successfully deactivated an employee.'}
      />
    </>
  );
};
